import { Flex } from '@teamsparta/stack-flex';
import Link from 'next/link';

import { useLoginFailedModal } from '@/store/campaign/failed';

import * as S from './style';

export function LoginFailedModal() {
  const { value: isModalOpen, close } = useLoginFailedModal();

  const handleModalClose = () => {
    close();
  };

  if (!isModalOpen) {
    return null;
  }

  return (
    <S.Overlay onClick={handleModalClose}>
      <S.Container>
        <Flex.Column gap='12px'>
          <S.Title>{'기부할 잔디가 없거나\n잔디를 불러오지 못했어요.'}</S.Title>
          <S.Description>
            1개 이하의 컨트리뷰션은 불러올 수 없어요.
          </S.Description>
        </Flex.Column>
        <S.ButtonWrapper>
          <S.CloseButton onClick={handleModalClose}>닫기</S.CloseButton>
          <Link href='https://github.com/login' target='_blank'>
            <S.RetryButton>내 잔디 확인하기</S.RetryButton>
          </Link>
        </S.ButtonWrapper>
      </S.Container>
    </S.Overlay>
  );
}
